module.exports = __webpack_public_path__ + "img/xzIco (6).ee3c1c52.png";